import { Outlet } from 'react-router-dom';
import { ReasonContextProvider } from 'modules/reason';
import { ShiftContextProvider } from 'modules/shift';
import { WeekDetailsContextProvider } from 'modules/week-details';
import { WorkPeriodsContextProvider } from 'modules/work-weeks';

export const WorkPage = () => (
  <WorkPeriodsContextProvider>
    <WeekDetailsContextProvider>
      <ShiftContextProvider>
        <ReasonContextProvider>
          <Outlet />
        </ReasonContextProvider>
      </ShiftContextProvider>
    </WeekDetailsContextProvider>
  </WorkPeriodsContextProvider>
);
